import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

type Props = {
    text: string;
    additionalText?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpandableText',
  props: {
    text: {},
    additionalText: {}
  },
  setup(__props: any) {



const { t } = useI18n();

const showDetails = ref<boolean>(false);

const buttonLabel = computed<string>(() => showDetails.value ? t('label.collapse') : t('label.details'));

const toggleDetails = (): void => {
    showDetails.value = !showDetails.value;
};

return (_ctx: any,_cache: any) => {
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _directive_orphans = _resolveDirective("orphans")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("p", {
      class: "d-inline sz-primary-grey--text",
      innerHTML: _ctx.text
    }, null, 8, _hoisted_1), [
      [_directive_orphans]
    ]),
    _createVNode(_component_v_expand_transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("p", { innerHTML: _ctx.additionalText }, null, 8, _hoisted_2), [
          [_vShow, showDetails.value],
          [_directive_orphans]
        ])
      ]),
      _: 1
    }),
    (_ctx.additionalText)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "d-block primary-link cursor-pointer",
          onClick: _withModifiers(toggleDetails, ["prevent","stop"])
        }, _toDisplayString(buttonLabel.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})